import { render } from "./bio-info-modal.vue?vue&type=template&id=9019a942&ts=true"
import script from "./bio-info-modal.vue?vue&type=script&lang=ts"
export * from "./bio-info-modal.vue?vue&type=script&lang=ts"

import "./bio-info-modal.vue?vue&type=style&index=0&id=9019a942&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__